import { useEffect, useState } from 'react';

// routing
import Routes from 'routes';

// project imports
import Locales from 'ui-component/Locales';
import NavigationScroll from 'layout/NavigationScroll';
import RTLLayout from 'ui-component/RTLLayout';
import Snackbar from 'ui-component/extended/Snackbar';
import Loader from 'ui-component/Loader';
import ErrorBoundary from 'components/ErrorBoundary';

import ThemeCustomization from 'themes';
import { dispatch } from 'store';
import { getMenu } from 'store/slices/menu';
import { loginUser, setInitialized } from 'store/slices/account';
import axios from 'axios';

// auth provider
// import { JWTProvider as AuthProvider } from 'contexts/JWTContext';
import { FirebaseProvider as AuthProvider } from 'contexts/FirebaseContext';
// import { AWSCognitoProvider as AuthProvider } from 'contexts/AWSCognitoContext';
// import { Auth0Provider as AuthProvider } from 'contexts/Auth0Context';

// ==============================|| APP ||============================== //

const App = () => {
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        const init = async () => {
            const { authManager } = await import('utils/authManager');
            let token = authManager.getToken();
            if (!token) {
                const legacy = typeof localStorage !== 'undefined' && localStorage.getItem('token');
                if (legacy) {
                    authManager.setToken(legacy, 'auth_token');
                    localStorage.removeItem('token');
                    token = authManager.getToken();
                }
            }
            if (!token) {
                dispatch(setInitialized());
                setLoading(true);
                return;
            }
            try {
                const apiSlice = (await import('store/slices/apiSlice')).default;
                const userRes = await dispatch(apiSlice.endpoints.loginTestToken.initiate(undefined)).unwrap();
                if (userRes?.user_token) localStorage.setItem('user_token', userRes.user_token);
                if (userRes?.email) localStorage.setItem('user_email', userRes.email);
                dispatch(loginUser({ user: { ...userRes, is_profile: true } }));
                axios.defaults.headers.common.Authorization = `Bearer ${token}`;
            } catch (error) {
                authManager.clearTokens();
                localStorage.removeItem('user_email');
                delete axios.defaults.headers.common.Authorization;
                dispatch(setInitialized());
                setLoading(true);
                return;
            }
            try {
                await dispatch(getMenu());
            } catch (_) {
                // menu lỗi không ảnh hưởng auth
            }
            setLoading(true);
        };
        init();
    }, []);

    if (!loading) return <Loader />;

    return (
        <ErrorBoundary>
            <ThemeCustomization>
                <RTLLayout>
                    <Locales>
                        <NavigationScroll>
                            <AuthProvider>
                                <>
                                    <Routes />
                                    <Snackbar />
                                </>
                            </AuthProvider>
                        </NavigationScroll>
                    </Locales>
                </RTLLayout>
            </ThemeCustomization>
        </ErrorBoundary>
    );
};

export default App;
